export default "__VITE_ASSET__CRvQ9LZs__"